module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/**\n * @module BandNode\n * \n */\ndefine(function () {\n    /**\n     * @class\n     * Store information for each spectra band of a species\n     * @param {number} wavelength - wavelength of the center of the band\n     * @param {number} width - half-width of the band\n     * @param {number} e - peak height\n     */\n    BandNode = function (wavelength, width, e) {\n        this.wavelength = wavelength;\n        this.width = width;\n        this.e = e;\n    };\n    return BandNode;\n});\n';

}
return __p
}